import React, { useState } from 'react';
import { AudioPlayer } from './AudioPlayer';
import { useNuPlayerContext } from '../NuPlayerContext';
import classnames from 'classnames';
import NuWave from './NuWave';

// eslint-disable-next-line react/prop-types
const NuPlayer = () => {
    const [ isHidden, setIsHidden ] = useState(false);
    const { isPlaying, stopTheMusic } = useNuPlayerContext();

    const audioPlayerClasses = classnames({
        'd-none': isHidden
    });

    const onCloseClick = () => {
        if(!isPlaying) {
            stopTheMusic();
        } else {
            setIsHidden(true);
        }
    };

    return <React.Fragment>
        <AudioPlayer className={audioPlayerClasses} onCloseClick={onCloseClick} />
        { (isPlaying && isHidden) && <div className="nuPlayerTabButton" onClick={() => setIsHidden(false)}>
            <NuWave />
        </div>}
    </React.Fragment>;
};

export default NuPlayer;
